$(document).ready(function () {
  $(".matches__inner__btns--prognozis .matches__inner__btn--day").click(
    function (evt) {
      evt.preventDefault();
      $(".matches__inner__btn").removeClass("matches__inner__btn--active");
      $(this).addClass("matches__inner__btn--active");
      $("#forecastLoadMore").hide();
      const sportId = $(".matches__inner__btns").data("sport-id");
      const date = $(this).data("date");

      $.ajax({
        method: "POST",
        url: "/ajax/forecastscalendar",
        data: { date: date, sportId: sportId },
      }).done(function (resp) {
        if (resp != "") {
          $(".forecasts__wrapper").html(resp);
        } else {
          $(".forecasts__wrapper").html(
            '<p class="forecast__response__text">На выбранную дату прогнозов нет</p>'
          );
        }
      });
    }
  );

  $("#matchesSearchBtn").click((evt) => {
    $(".matches__inner__links").addClass("matches__inner__links--active");
  });

  $("#matchesCloseBtn").click((evt) => {
    $(".matches__inner__links").removeClass("matches__inner__links--active");
  });

  let dirty = false;
  $(
    ".matches__inner__search__form .matches__inner__search__input--prognozis"
  ).keyup(function () {
    const query = $(".matches__inner__search__input--prognozis").val();
    const parents = $(".matches__inner__search__form").data("parents");
    if (this.value.length > 2) {
      $(".forecasts__wrapper").html(
        '<p class="forecast__response__text">Идет поиск...</p>'
      );
      dirty = true;
      $("#forecastLoadMore").hide();
      $.ajax({
        method: "POST",
        url: "/ajax/forecastssearchajax",
        data: { query: query, parents: parents },
      }).done(function (resp) {
        if (resp != "") {
          $(".forecasts__wrapper").html(resp);
        } else {
          $(".forecasts__wrapper").html(
            '<p class="forecast__response__text">По вашему запросу ничего не найдено</p>'
          );
        }
      });
    }

    if (this.value.length <= 2 && dirty) {
      dirty = false;
      $(".forecasts__wrapper").html(
        '<p class="forecast__response__text">Идет поиск...</p>'
      );
      $.ajax({
        method: "POST",
        url: "/ajax/forecastsloadreturn",
      }).done(function (resp) {
        $(".forecasts__wrapper").html(resp);
      });
    }
  });
});
